export const LONDON_TIMEZONE = 'Europe/London';

export function localDate(date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: LONDON_TIMEZONE }).format(date);
}

export function localDateTime(date = new Date()): string {
  return date.toISOString();
}

export function formatShortDate(value: string): string {
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(
    new Date(`${value}T12:00:00Z`),
  );
}
